import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Box from "@mui/material/Box";
import MuiTable from "@mui/material/Table";
import MuiTableBody from "@mui/material/TableBody";
import MuiTableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import MuiTableHead from "@mui/material/TableHead";
import MuiTableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";
const DynamicTableSkeleton = (t0) => {
  const $ = c(15);
  const {
    colCount: t1,
    rowCount: t2
  } = t0;
  const colCount = t1 === void 0 ? 3 : t1;
  const rowCount = t2 === void 0 ? 5 : t2;
  let t3;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      padding: "20px",
      width: "100%"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== colCount) {
    t4 = new Array(colCount).map(_temp);
    $[1] = colCount;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = /* @__PURE__ */ jsx(MuiTableHead, { children: /* @__PURE__ */ jsx(MuiTableRow, { children: t4 }) });
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== colCount || $[6] !== rowCount) {
    let t72;
    if ($[8] !== colCount) {
      t72 = (__0, rowIndex) => /* @__PURE__ */ jsx(MuiTableRow, { children: new Array(colCount).map(_temp2) }, `skeleton-row-${rowIndex}`);
      $[8] = colCount;
      $[9] = t72;
    } else {
      t72 = $[9];
    }
    t6 = new Array(rowCount).map(t72);
    $[5] = colCount;
    $[6] = rowCount;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = /* @__PURE__ */ jsx(MuiTableBody, { children: t6 });
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = /* @__PURE__ */ jsx(Box, { sx: t3, children: /* @__PURE__ */ jsx(TableContainer, { children: /* @__PURE__ */ jsxs(MuiTable, { children: [
      t5,
      t7
    ] }) }) });
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(_, index) {
  return /* @__PURE__ */ jsx(MuiTableCell, { children: /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "100%", height: 30 }) }, index);
}
function _temp2(__1, colIndex) {
  return /* @__PURE__ */ jsx(MuiTableCell, { children: /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "100%", height: 20 }) }, colIndex);
}
export {
  DynamicTableSkeleton as default
};
